import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ManageYieldService } from 'src/app/services/manage-yield.service';
import { Location } from "@angular/common";

declare const $:any;

@Component({
  selector: 'smart-manage-yield-edit',
  templateUrl: './manage-yield-edit.component.html',
  styleUrls: ['./manage-yield-edit.component.scss','../../platform-color/platform-color.css']
})
export class ManageYieldEditComponent implements OnInit {
  form: FormGroup;
  submitted: boolean = false;
  status: string = "";
  farm_id: string = "";
  yield_template_id: string = "";
  successModal: string = '#successModal';
  errorModal: string = '#errorModal';

  yieldData: any;
  yield: any = [];
  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private ManageYieldService: ManageYieldService,

    private cd: ChangeDetectorRef
  ) { 
    this.route.queryParams
    .subscribe(params => {
      this.status = params.status;
      this.farm_id = params.farm_id;
    }
  );
  this.yield_template_id = 
  this.route.snapshot.paramMap.get("yield_template_id");
  }

  createForm(){
    this.form = this.formBuilder.group({
      yield: this.formBuilder.array([]),
    });

    this.yield = this.form.get('yield') as FormArray;
  }

  getYieldFormGroup(index): FormGroup {
    this.yield = this.form.get('yield') as FormArray;
    const formGroup = this.form.controls[index] as FormGroup;
    return formGroup;
  }
  get yieldItemFormGroup() {
    return this.form.get('yield') as FormArray;
  }
  createYieldItem(data:any = {}): FormGroup {
    return this.formBuilder.group({
      editable: this.formBuilder.control(data.editable),
      _id: this.formBuilder.control(data._id),
      input_type: this.formBuilder.control({ value: data.input_type, disabled: !data.editable }),
      name: this.formBuilder.control({ value: data.name, disabled: !data.editable }, [Validators.required]),
      no: this.formBuilder.control({ value: data.no, disabled: !data.editable }),
      show: this.formBuilder.control({ value: data.show, disabled: !data.editable }),
      input_choices: this.formBuilder.control({value: data.input_choices, disabled: false}, [Validators.minLength(1)]),

      choice: this.formBuilder.control({ value: "", disabled: !data.editable }),
      errorChoice: this.formBuilder.control(false),
    });
  }

  ngOnInit(): void {
    this.createForm();
    if(this.status == 'Master'){
      this.getMainYieldTemplate();
    }else{
      this.getYieldTemplate();
    }
  }

  async getMainYieldTemplate(){
    this.spinner.show();
    this.ManageYieldService.getMainYieldTemplatesById(this.yield_template_id).subscribe(res=>{
      this.yieldData = res.data[0];
      if(this.yieldData.yield.length > 0){

        for(let i = 0; i < this.yieldData.yield.length; i++){
          
          this.yield.push(
            this.createYieldItem(this.yieldData.yield[i])
          );
        }

      }
      this.spinner.hide();
      this.cd.detectChanges();
    })
  }

  async getYieldTemplate(){
    this.spinner.show();
    this.ManageYieldService.getYieldTemplatesById(this.yield_template_id).subscribe(res=>{
      this.yieldData = res.data[0];
      if(this.yieldData.yield.length > 0){

        this.yieldData.yield.sort((a,b) => a.no - b.no);

        for(let i = 0; i < this.yieldData.yield.length; i++){

          this.yield.push(
            this.createYieldItem(this.yieldData.yield[i])
          );
        }

      }
      this.spinner.hide();
      this.cd.detectChanges();
    })
  }

  save(){
    this.submitted = true;
    if(this.form.invalid || this.form.getRawValue().yield.find(y=> y.input_choices.length == 0 && y.input_type == 'choice')){
      return;
    }
    let yields =  this.form.getRawValue().yield.map(item=>{
      return{
        _id: item._id,
        editable: item.editable,
        input_type: item.input_type,
        name: item.name,
        no: item.no,
        show: item.show,
        input_choices: item.input_choices,
      }
    })

    let data = {
      org_id: sessionStorage.getItem('Org'),
      child_org_id: sessionStorage.getItem('ChildOrg'),
      farm_id: this.farm_id,
      package_id: this.yieldData.package_id,
      package_name: this.yieldData.package_name,
      max_field_no: this.yieldData.max_field_no,

      breed_type_id: this.yieldData.breed_type_id,
      breed_type_name: this.yieldData.breed_type_name,
      status: "Edited",
      yield: yields
    };

    if(this.status == 'Master'){
      this.ManageYieldService.createYieldTemplates(data).subscribe(res=>{
        if(res.code ==200){
          $(`${this.successModal}`).modal("show");
        }else{
          $(`${this.errorModal}`).modal("show");
        }
      })
    }else{
      this.ManageYieldService.updateYieldTemplates(data, this.yield_template_id).subscribe(res=>{
        if(res.code ==200){
          $(`${this.successModal}`).modal("show");
        }else{
          $(`${this.errorModal}`).modal("show");
        }
      })
    }
    this.submitted = false;
  }

  addChoice(index){
    let choice = this.yield.getRawValue()[index].choice;
    let input_choices = this.yield.getRawValue()[index].input_choices;

    if(choice.trim() != "" && input_choices.length <= 9){
      this.yield.controls.map((yie, indexYie)=>{

        if(index === indexYie){

          let data = input_choices;
          data.push({
            no: input_choices.length + 1,
            choice: choice
          })

          yie.get('choice').setValue("");
          yie.get('input_choices').setValue(data);
          yie.get('errorChoice').setValue(false);
        }
      })
    }else{
      if(choice.trim() != ""){
        this.yield.controls.map((yie, indexYie)=>{
          if(index === indexYie){
      
            yie.get('errorChoice').setValue(true);
          }
        })
      }
    }

  }

  removeChoice(index, indexChoice){
    let input_choices = this.yield.getRawValue()[index].input_choices;

    if (indexChoice > -1) { 
      input_choices.splice(indexChoice, 1);
    }

    this.yield.controls.map((yie, indexYie)=>{
      if(index === indexYie){
    
        yie.get('errorChoice').setValue(false);
        yie.get('input_choices').setValue(input_choices);
      }
    })
  }

  back(): void {
    this.location.back();
  }
}
